// extracted by mini-css-extract-plugin
export default {"container":"WrEXuFxfLkG3untbfZp3"};